import admin from './admin';
import seller from './seller';
import errorRoutes from './Modules/error';
import commonRoutes from './Modules/common';

const modules = {
    admin,
    seller,
};

const roleModule = {
    load: (role) => {
        if (role && modules[role]){
            const { routes, menu } = modules[role];
            const routesWithErrors = [
                ...errorRoutes, // This must be first to avoid route composition
                ...commonRoutes,
                ...routes
            ];
            return {
                routes: routesWithErrors,
                menu,
            };
        }

        return {
            routes: [],
            menu: { items: []},
        };
    }
}

export default roleModule;


// WEBPACK FOOTER //
// ./src/Routes/RouteLoader.js